import React from 'react';
import Widgets from '../Widgets';
import { LegendNumeric, PieChart, FilterDate, InfoGroup } from '../../../components';
import { isEqual } from 'lodash';

import './WidgetPieNumeric.css';

export default class WidgetPieNumeric extends Widgets {
  componentDidUpdate(props, state) {
    if (!isEqual(this.props.filters, props.filters) && (this.props.filtersLoaded))
      return this.props.fetchData(this.props.filters)
  }

  componentDidMount() {
    if (this.props.filtersLoaded) return this.props.fetchData(this.props.filters)
  }

  render() {
    if (this.props.loaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetPieNumeric` : 'WidgetPieNumeric'} style={this.props.style}>
          <h1 className="title">{this.props.title} {this.props.onZoom ? <a onClick={this.props.onZoom}><i className="fa fa-search"></i></a> : null} {this.props.close ? <a onClick={this.props.close}><i className="fa fa-times"></i></a> : null}</h1>
          <div style={{'width': '60%', 'float': 'left'}}>
            <PieChart
              colorScheme={this.props.colorScheme}
              data={this.props.graph ? this.props.graph : []}
              size={[this.props.width * 0.7, this.props.height * 0.7]}
            />
            <br />
          </div>
          { this.props.infoItems ? <div className="infoBlocks" style={{'width': this.props.width * 0.7, 'float': 'left', 'top': '60px', 'left': '370px'}}>
            { this.props.infoItems ? <InfoGroup data={this.props.infoItems} colorScheme={this.props.colorScheme} className='WidgetPieNumeric' /> : null }
          </div> : null }
        </div>
      );
    else if (!this.props.loaded && this.props.filtersLoaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetPieNumeric` : 'WidgetPieNumeric'} style={this.props.style}>
          <img src={`${process.env.PUBLIC_URL}/loading.svg`} />
        </div>
      );
    else
      return (
        <div className={this.props.className ? `${this.props.className} WidgetPieNumeric` : 'WidgetPieNumeric'} style={this.props.style}>
          <h1>select operator and service to see stats</h1>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetPieNumericComponent/WidgetPieNumeric.js